<template>
  <!-- 联系客服 -->
  <div class="connect">
    <div class="top">
      <div class="title">联系客服</div>
      <div class="info">
        如在使用过程中遇到任何问题，可通过下面的“二维码”联系在线客服。<br />
        或有更多意见/建议，欢迎在【反馈意见】处提交您的建议与意见。
      </div>
    </div>
    <div class="wechat">
      <span>扫描下方二维码联系客服</span>
      <!-- <img src="../../assets/serve/pic_lxkf@2x.png" alt="" class="image" /> -->
     <!-- <img :src="qrcode | urlLoad" alt="" class="image" />-->
<img src="https://yousubao.oss-cn-shenzhen.aliyuncs.com/head/jpg/2024-12-13/erweima.jpg" alt="" />
      <!-- <span>联系电话：{{ phone }}</span> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      qrcode: "",
    };
  },
  created() {
    this.connectServices();
  },
  methods: {
    async connectServices() {
      let params = {};
      let res = await this.$apiFun.connectServices(params);
      // this.supportList = res.result.rows;
      if (res.code == 200) {
        this.phone = res.result.hotline;
        this.qrcode = res.result.customerServiceQrCode;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.connect {
  width: 95%;
  height: 96%;
  background: #fff;
  padding-top: 0.3rem;
  padding-left: 0.5rem;
  .top {
    font-family: Microsoft YaHei;
    text-align: left;
    .title {
      font-size: 0.24rem;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.3rem;
    }
    .info {
      font-size: 0.18rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: 1rem;
    }
  }
  .wechat {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.22rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 0.3rem;
    img {
      width: 4rem;
      height: 5rem;
      margin: 0.3rem 0;
    }
  }
}
</style>